/* NEXSORA premium homepage behaviour. No dependencies. */
(function () {
  'use strict';
  if (window.__hxLoaded) return;
  window.__hxLoaded = true;
  var mqR = window.matchMedia('(prefers-reduced-motion: reduce)');
  var reduced = function () { return mqR.matches; };
  var canHover = function () { return window.matchMedia('(hover: hover) and (pointer: fine)').matches; };
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Reveals: animate in whenever they enter view */
  function initReveal(scope) {
    var els = qsa('.hx-rv', scope);
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) en.target.classList.add('is-in');
        else if (!reduced()) en.target.classList.remove('is-in');
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { if (!e.__hxr) { e.__hxr = 1; io.observe(e); } });
  }

  /* Pause endless background animations while their section is off screen (saves battery and keeps scrolling smooth) */
  function initPause(scope) {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.target.classList.toggle('is-off', !en.isIntersecting); });
    }, { rootMargin: '10% 0px' });
    qsa('.hx-hero,.hx-strip,.hx-final,.hx-spot', scope).forEach(function (s) { if (!s.__hxo) { s.__hxo = 1; io.observe(s); } });
  }

  /* Scroll progress: --hs on the hero, --sp on sections that use it. Only on-screen sections are touched. */
  var active = [], ticking = false;
  function frame() {
    ticking = false;
    var vh = window.innerHeight;
    for (var i = 0; i < active.length; i++) {
      var s = active[i], r = s.getBoundingClientRect(), hero = s.hasAttribute('data-hx-hero'), p;
      p = hero ? -r.top / Math.max(1, r.height) : (vh - r.top) / (vh + r.height);
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      if (s.__lp === undefined || Math.abs(p - s.__lp) > 0.003) { s.__lp = p; s.style.setProperty(hero ? '--hs' : '--sp', p.toFixed(3)); }
    }
  }
  function req() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  function initProgress(scope) {
    if (reduced() || !('IntersectionObserver' in window)) return;
    if (!initProgress.io) {
      initProgress.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var i = active.indexOf(en.target);
          if (en.isIntersecting && i < 0) active.push(en.target);
          if (!en.isIntersecting && i > -1) active.splice(i, 1);
        });
        req();
      }, { rootMargin: '10% 0px 10% 0px' });
      window.addEventListener('scroll', req, { passive: true });
      window.addEventListener('resize', req, { passive: true });
    }
    qsa('[data-hx-hero],[data-hx-sec]', scope).forEach(function (s) { if (!s.__hxp) { s.__hxp = 1; initProgress.io.observe(s); } });
  }

  /* Hero: gentle pointer movement (desktop only, no layout reads) */
  function initHero(scope) {
    var hero = qs('[data-hx-hero]', scope);
    if (!hero || hero.__hxh || reduced() || !canHover()) return;
    hero.__hxh = 1;
    var raf = 0, x = 0, y = 0;
    function paint() { raf = 0; hero.style.setProperty('--mx', x.toFixed(3)); hero.style.setProperty('--my', y.toFixed(3)); }
    hero.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      x = (e.clientX / window.innerWidth - 0.5) * 2;
      y = (e.clientY / window.innerHeight - 0.5) * 2;
      if (!raf) raf = requestAnimationFrame(paint);
    });
    hero.addEventListener('pointerleave', function () { x = 0; y = 0; if (!raf) raf = requestAnimationFrame(paint); });
  }

  /* Smooth scroll for in-page buttons (also moves keyboard focus so it stays accessible) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-hx-scroll]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '#') return;
    var t = qs(href);
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
  });

  function init(scope) { initReveal(scope); initPause(scope); initProgress(scope); initHero(scope); }
  if (document.readyState !== 'loading') init(document); else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();